var map = {
	"./AppImages/gold.png": 1323,
	"./AppImages/pllatin.png": 1171,
	"./AppImages/silver.png": 8174,
	"./AppImages/tc.png": 2954,
	"./Avatar/Avatar1.png": 5217,
	"./Avatar/Avatar2.png": 554,
	"./gold.png": 6393,
	"./platinium.png": 1426,
	"./silver.png": 6912,
	"./user.png": 1234
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5624;